import moment from "moment"

export const convertDateExport = (datetime: string) =>
  datetime ? moment(datetime).utc().format("YYYYMMDD") : ""
